import React from "react";
import SortVisualizer from "./components/SortVisualizer";
import Footer from "./components/footer";

function App() {
  return (
    <div className="App">
      <SortVisualizer />
      <Footer />
    </div>
  );
}

export default App;